<footer id="footer" class="container-fluid">
    <div>
        <p>
            <strong>A GSPANN Product</strong>. Copyright &copy;
            {{currentDate | date: 'yyyy'}} GSPANN Technologies, Inc. All Rights Reserved.
        </p>
    </div>
</footer>
